const default_settings = {
  env: 'beta',
  debug: true,
  api_host: 'https://freedom-beta.workpilots.com',
  api_version: '8',
  notifier_url: 'wss://freedom-beta.workpilots.com/ws/',
  sentry_dsn: '',
  default_lang: 'en',
  seitatech_client_url: 'https://testweid.seitatech.fi:443/mobile',
  nets_host: 'https://test.epayment.nets.eu',
  google_maps_api_key: 'AIzaSyD-i_eg2Ss8IrOiZb-25Bc2N33YKG2cDCM',
  google_places_api_key: 'AIzaSyAh8dl4JG0l6dqVGK-8F6rq8cfIEFXRN1s',
  google_geocode_api_key: 'AIzaSyBCL9I2zoXHbgf6tLiGvkRP70biwGWQ-dw',
  recorder_key: '',
  recorder_url: '',
  base_domain: 'workpilots.com',
  default_subdomain: 'web',
  default_subdomains: ['localhost:9000', 'freedom-beta', 'web'],
  supported_languages: ['en', 'fi', 'sv', 'ru', 'fa', 'uk'],
};

export { default_settings };
